import { render, staticRenderFns } from "./PubQuoteEdit.vue?vue&type=template&id=05e50a62&"
import script from "./PubQuoteEdit.vue?vue&type=script&lang=js&"
export * from "./PubQuoteEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PubQuoteEdit.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardTitle,
  VContainer,
  VFlex,
  VForm,
  VLayout,
  VToolbar,
})
